import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import '../scss/universal-table.scss';

import { round } from 'mathjs';
import { cloneDeep } from 'lodash';
import Color from '@/tool/color';

interface IProps {
  labelList?: string[]
  rateList?: Array<any>,
  legendList: string[],
  code?: string
  type?: string
}
interface IState { }

const UniversalTable = (props: IProps, state: IState) => {
  const { labelList, rateList, legendList, code, type } = props;
  const itemLength = (1 / (legendList?.length + 1)) * 100;
  const rightLength = (legendList?.length / (legendList?.length + 1)) * 100;
  const rightItemLength = (100 / legendList?.length);
  useEffect(() => {
    return () => { };
  }, []);

  const addArray = (rateArr: any, arr: any) => {
    const list = rateArr?.map((item: any) => {
      const items = { ...item };
      for (let i = 0; i < arr.length; i += 1) {
        if (i >= items?.data?.length) {
          items?.data?.push({ rate: '-' });
        }
      }
      return items;
    });
    return list;
  };
  const newRateList = cloneDeep(rateList);
  const newQuarterList = cloneDeep(legendList);

  const getResult = (val: any) => {
    let str: any;
    if (typeof (val) === 'string') {
      str = val;
    } else {
      str = val || val === 0 ? Number(val).toLocaleString() : '-';
    }
    return str;
  };

  const getRateResult = (val: any) => {
    let str: any;
    if (typeof (val) === 'string') {
      str = val;
    } else {
      str = val || val === 0 ? ` ${round(val * 100, 1)}% ` : '-';
    }
    return str;
  };

  return (
    <section className="universal-year-table">
      <section className="universal-year-table-left"
        style={{ width: `${itemLength}% `, marginTop: '32px' }}>
        {
          labelList?.map((item, i) => (
            <p key={i.toString()}>{item}{code === 'year' && '年'}</p>
          ))
        }
      </section>
      <section className="universal-year-table-right"
        style={{
          width: `${rightLength}% `,
          paddingRight: '20px',
          marginLeft: 0,
        }}>
        <section
          style={{ display: 'flex', justifyContent: 'space-between' }}>
          {legendList?.map((item, i) => (
            <p key={i.toString()}
              style={{ width: `${rightItemLength}% `, color: Color.blackColor(0.5) }}>
              {item}
            </p>
          ))}
        </section>

        {
          addArray(newRateList, newQuarterList)?.map((item: any, i: number) => (
            <section key={i.toString()}
              style={{ display: 'flex', justifyContent: 'space-between' }}>
              {item?.data?.map((res: any, r: number) => (
                <p key={r.toString()} style={{ width: `${rightItemLength}% ` }}>
                  {type === 'number' ? getResult(Math.round(res?.rate)) :
                    getRateResult(res?.rate)}
                </p>
              ))}
            </section>
          ))
        }
      </section>
    </section>
  );
};

export default observer(UniversalTable);
